/**
 * RaisedSplitButton.js
 * Raised split button with dropdown
 *
 * @class RaisedSplitButton
 * @author  Yevgeniy Rokhlin
 */

import React from 'react';
import ClassNames from 'classnames';
import Menu from 'components/menu/Menu';
import RaisedButton from 'components/buttons/raised-button/RaisedButton';
import ClickAway from 'mixins/js/ClickAway';
import DropDownIcon from 'components/svg-icons/drop-down-arrow';
import Container from 'components/flexbox/Container';
import Block from 'components/flexbox/Block';


export default React.createClass({
	
	mixins: [ ClickAway ],

	manuallyBindClickAway: true,


	displayName: "RaisedSplitButton",

	propTypes: {
		autoWidth: React.PropTypes.bool,
		menuItems: React.PropTypes.array.isRequired,
		status: React.PropTypes.string,
		rounded: React.PropTypes.bool,
		label: function(props, propName, componentName) {
			if (!props.children && !props.label) {
				return new Error('Warning: Required prop `label` or `children` was not specified in `' + componentName + '`.')
			}
		},
	},

	getInitialState(){
		return {
			open: false,
			selectedIndex: this.props.selectedIndex || 0

		}
	},

	getDefaultProps(){
		return {
			status: "primary",
			rounded: true,
			autoWidth: true
		}
	},

	componentDidUpdate(){
		if (this.state.open) {
			this._bindClickAway();
		} else {
			this._unbindClickAway();
		}

	},

	componentClickAway(){
		this.setState({
			open: false
		});
	},

	render() {
		let { 
			children,	
			label,
			status,
			disabled,
			rounded,
			autoWidth,
			menuItems,
			className } = this.props;

		let wrapperClass = ClassNames('lui-drop-down-menu', 'lui-raised-split-button-wrapper', `lui-is-${this.props.status}`, {
			'lui-open': this.state.open,
			'lui-is-rounded': rounded,
			'lui-is-disabled': disabled
		});

		let buttonClasses = ClassNames('lui-raised-split-button', className);

		let dropDownButtonClasses = ClassNames('lui-raised-split-drop-down-button');

		return (
			<div>
				<Container className={wrapperClass} flexDirection="row" justifyContent="center">
					<Block width={0.8}>
						<RaisedButton 
							className={buttonClasses}
							label={label} 
							status={status} 
							onClick={this._handleClick}
							disabled={disabled} />              
					</Block>
					<Block width={0.2}>
						<RaisedButton 
							className={dropDownButtonClasses}
							status={status} 
							onClick={this._handleClick}
							disabled={disabled} >

							<DropDownIcon key="dropdown" className="lui-menu-drop-down-icon" />
						</RaisedButton>
					</Block>
						<Menu
							ref="menuItems"
							autoWidth={autoWidth}
							selectedIndex={this.state.selectedIndex}
							menuItems={menuItems}
							hideable={true}
							visible={this.state.open}
							status={status}
							onItemClick={this._onMenuItemClick} />
				</Container>
			</div>
		);
	},

	_handleClick(){
		this.setState({
			open: !this.state.open
		});
	},

	_onMenuItemClick: function(e, key, payload) {
		this.setState({
		  selectedIndex: key,
		  open: false
		});
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/raised-button/RaisedSplitButton.js
 **/